export default __webpack_public_path__ + "static/media/cave.b3ba89f4.ogg";